<template lang="pug">
AppDialog.app-confirm(
  append-to-body
  has-footer
  :size="size"
  :show="show"
  :title="title"
  data-testid="confirmation-dialog"
  @close="onCancel"
)
  slot
  template(#footer)
    AppButton(
      :type="cancelButtonType"
      @click="onCancel"
    ) {{ cancelLabel }}
    AppButton(
      :type="confirmButtonType"
      data-testid="confirmation-dialog-ok"
      @click="onConfirm"
    ) {{ confirmLabel }}
</template>

<script>
export default {
  name: 'AppConfirm',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Please confirm',
    },
    confirmLabel: {
      type: String,
      default: 'Ok',
    },
    confirmButtonType: {
      type: String,
      default: 'primary',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    cancelButtonType: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'smedium',
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>
